import { RArray } from "../../collections";
import { RDate, makeImmutable } from "../../core";
import { ASAPFulfillmentTime, OnTimeFulfillmentTime, } from "../FulfillmentTime";
export class CheckoutInfo {
    constructor(params) {
        this.checkoutInfo = params.checkoutInfo;
        this.timezone = params.timezone;
        makeImmutable(this);
    }
    get fulfillmentTimes() {
        return new RArray(this.checkoutInfo.fulfillmentTimes).map(({ label, value }) => value === null
            ? new ASAPFulfillmentTime(label)
            : new OnTimeFulfillmentTime({
                date: RDate.fromString(value, this.timezone),
                label,
            }));
    }
    // TODO Arrange payment methods cleverly
    get paymentMethods() {
        return new RArray(this.checkoutInfo.paymentMethods);
    }
    get fulfillmentMethods() {
        return new RArray(this.checkoutInfo.fulfillmentMethods);
    }
    get franchiseName() {
        return this.checkoutInfo.franchiseName;
    }
}
